"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-donato-milanese": {
    "7b1296d1": [{
      "hkey": "7561105c",
      "slug": "concentrico",
      "name": "Concentrico",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "7561105c",
      "slug": "concentrico",
      "name": "Concentrico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "04689658": [{
      "hkey": "d762543e",
      "slug": "certosa",
      "name": "Certosa",
      "primary": true,
      "skipSearch": false
    }],
    "di-vittorio": [{
      "hkey": "d762543e",
      "slug": "certosa",
      "name": "Certosa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "aae7ae4f": [{
      "hkey": "84c3c400",
      "slug": "metanopoli-triulzio",
      "name": "Metanopoli-Triulzio",
      "primary": true,
      "skipSearch": false
    }],
    "metanopoli": [{
      "hkey": "84c3c400",
      "slug": "metanopoli-triulzio",
      "name": "Metanopoli-Triulzio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;